'use client';
import { Honeybadger, HoneybadgerErrorBoundary } from '@honeybadger-io/react';
import type { ReactNode } from 'react';

export default function HoneyBadger({ children }: { children: ReactNode }) {
  return <HoneybadgerErrorBoundary honeybadger={Honeybadger}>{children}</HoneybadgerErrorBoundary>;
}
